import React from "react";

function CreatemusicvenueIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF">
          <path d="M16 13.264l-.106-2.556c0-.32-.158-.586-.423-.693a.807.807 0 00-.846 0l-8.46 4.314c-.37.213-.582.639-.423 1.064.053.213.211.373.37.48.159.106.37.16.582.106l8.566-1.704c.476-.213.74-.585.74-1.011"></path>
          <path d="M1.67 9.856L7.381 2.72c.159-.213.264-.479.212-.745-.053-.266-.212-.533-.476-.639L5.002.111c-.212-.106-.53-.16-.74-.053-.265.107-.477.266-.582.533L.084 8.95c-.211.425 0 .958.37 1.17 0 0 .053 0 .053.054.37.107.846.053 1.163-.32"></path>
          <path d="M11.717 2.774l-7.826 8.04a.906.906 0 00-.053 1.225c.053.106.159.16.265.213.264.16.634.16.951-.053l9.941-6.39c.265-.16.423-.533.423-.852 0-.32-.264-.586-.528-.799-.265-.213-1.851-1.49-2.115-1.65-.212-.107-.794 0-1.058.266"></path>
        </g>
      </g>
    </svg>
  );
}

export default React.memo(CreatemusicvenueIcon);
